module.exports = __webpack_public_path__ + "static/img01-e372d0cec009cb256025af3884918164.jpg";